import { types as t, Instance } from 'mobx-state-tree';
import Fetchable from '~/mst/models/abstract/fetchable';

const SuggestionsModel = t.compose(
  t.model({
    data: t.array(t.string)
  }),
  Fetchable({ cache: false })
);

export interface ISuggestionsModel extends Instance<typeof SuggestionsModel> {}

export default SuggestionsModel;
